import React, { useState } from 'react';
import { TextField, Button, Box, Typography } from '@mui/material';
import emailjs from 'emailjs-com';

const ContactMe: React.FC = () => {
  // State for form inputs
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    const formData = {
      name,
      email,
      subject,
      message,
    };

    try {
      const result = await emailjs.send(
        'service_zsrkz3j',
        'template_c2nvrx1',
        formData,
        'lL5xFCpNLx-0NzdYJ'
      );
      
      console.log(result.text);
      setStatus('Message sent successfully!');
      
      setName('');
      setEmail('');
      setSubject('');
      setMessage('');
    } catch (error) {
      console.log(error);
      setStatus('Failed to send message. Please try again.');
    }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: '600px', margin: 'auto', padding: '20px' }}>
      <Typography variant="h4" sx={{ marginBottom: '20px' }}>Contact Me</Typography>
      
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <TextField
          label="Name"
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          required
          sx={{ marginBottom: '10px' }}
        />
        <TextField
          label="Email"
          variant="outlined"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          required
          sx={{ marginBottom: '10px' }}
        />
        <TextField
          label="Subject"
          variant="outlined"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          fullWidth
          required
          sx={{ marginBottom: '10px' }}
        />
        <TextField
          label="Message"
          variant="outlined"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          fullWidth
          multiline
          rows={4}
          required
          sx={{ marginBottom: '20px' }}
        />
        
        <Button type="submit" variant="contained" style={{backgroundColor: 'burlywood'}} fullWidth>
          Submit
        </Button>
      </form>
      
      {status && <Typography sx={{ marginTop: '20px', textAlign: 'center' }}>{status}</Typography>}
    </Box>
  );
};

export default ContactMe;
